// Special Issue deadline display, shared by the public listing card and
// detail page. `submission_deadline` is a date-only column serialized as
// plain YYYY-MM-DD (SpecialIssue's `date:Y-m-d` cast) — it is formatted as
// UTC so no viewer timezone can shift it to the previous day.

function deadlineDate(value) {
    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value || '');
    return match ? new Date(Date.UTC(+match[1], +match[2] - 1, +match[3])) : null;
}

export function formatDeadline(value) {
    const date = deadlineDate(value);
    return date ? date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' }) : null;
}

// 'passed' once the deadline day is over, 'soon' within 30 days, else 'future'.
export function deadlineState(value) {
    const date = deadlineDate(value);
    if (!date) return null;
    const diff = date.getTime() + 24 * 60 * 60 * 1000 - Date.now();
    if (diff < 0) return 'passed';
    if (diff < 30 * 24 * 60 * 60 * 1000) return 'soon';
    return 'future';
}

// The status a visitor sees: an Active issue whose deadline has passed reads
// as Closed straight away, before the nightly special-issues:close-expired
// run stores it (App\Jobs\CloseExpiredSpecialIssuesJob).
export function displayStatus(specialIssue) {
    if (specialIssue?.status === 'active' && deadlineState(specialIssue.submission_deadline) === 'passed') {
        return 'closed';
    }
    return specialIssue?.status;
}
